import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Nshock } from '../nshock';



@Component({
    selector: 'nsp2p1',
    templateUrl: './nsp2p1.component.html',
    styleUrl: './nsp2p1.component.scss',
    standalone: false
})
export class Nsp2p1Component implements OnInit {

  p2p1Form: FormGroup | undefined;
  p2p1Bool?: boolean;
  p2p1Shock: Nshock | undefined;


  constructor(private fBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.p2p1Form = this.fBuilder.group({
      gVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
      ]],
      pVal: ''
    })

  }



  onSubmit(): void {
    this.p2p1Shock = new Nshock();
    this.p2p1Bool = true;
    this.p2p1Shock.gammaVal = Number(this.p2p1Form?.get('gVal')?.value);
    this.p2p1Shock.p2p1 = Number(this.p2p1Form?.get('pVal')?.value);
    console.log(this.p2p1Shock);
    this.p2p1Shock.m1 = this.m1_from_p1p2(this.p2p1Shock.gammaVal, this.p2p1Shock.p2p1);
    this.p2p1Shock.nShockCalc(this.p2p1Shock.gammaVal, this.p2p1Shock.m1);
  }


  m1_from_p1p2(g:number, p:number): number {
    let gp1 =g+1;
    let m1=Math.sqrt( (p-1.) * (gp1) / 2. / g + 1.) ;
    return Number(m1.toFixed(2));
  }

  nsm1() {
    return this.p2p1Shock?.m1;
  }

  nsm2() {
    return this.p2p1Shock?.m2;
  }

  // nsp2p1() {
  //   return this.nsMap.get("p2/p1");
  // }

  nst2t1() {
    return this.p2p1Shock?.t2t1;
  }

  nsdva1() {
    return this.p2p1Shock?.dva1;
      }

  nspt2_pt1() {
    return this.p2p1Shock?.pt2pt1;
  }

  nspt2_p1() {
    return this.p2p1Shock?.pt2p1;
  }



}
